import { ProjectAppTypes, useEnvProvider } from '@bechtel/client-common';
import { Module } from '@bechtel/types';
import { defineMessage } from '@lingui/macro';
import { findIndex } from 'lodash';
import { moduleExtData } from './form-data';
import { AppModuleExt } from './types';

export function useModuleExtended() {
  const { envConfig } = useEnvProvider();
  const isASAppType = envConfig.appName === ProjectAppTypes.AS;
  const getModuleExtendedList = () => {
    const moduleList = [...moduleExtData];
    const notificationModuleIndex = findIndex(
      moduleList,
      (item: AppModuleExt) => item.moduleTypeId === Module.NOTIFICATIONS
    );
    if (notificationModuleIndex != -1) {
      const notificationModule = moduleList[notificationModuleIndex];
      if (isASAppType) {
        notificationModule.moduleDescription = defineMessage({
          message: `Get key notifications in the ArcStryker application (turn individual notifications on/off in Project Admin).`,
        }).id;
      }
      moduleList.splice(notificationModuleIndex, 1, notificationModule);
    }
    return moduleList;
  };
  return {
    getModuleExtendedList,
  };
}
